<template>
  <el-tooltip class="item" effect="dark" content="输入数字时按ID查询，否则按名称查询" placement="top">
    <el-select
            v-if="keyType == 1"
            v-model="data"
            value-key="name"
            v-bind="$attrs"
            filterable
            remote
            :remote-method="search"
            :loading="loading"
            @change="onChange"
            @clear="onClean"
            ref="siteAutoComplete"
            placeholder="请输入站点名称/ID"
    >
        <el-option
            v-if="dataType==1"
            label="全部"
            value="0"
        >
        </el-option>
        <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="item.name">
        </el-option>
        
    </el-select>
    <el-select
            v-else
            v-model="data"
            value-key="name"
            v-bind="$attrs"
            filterable
            remote
            :remote-method="search"
            :loading="loading"
            @change="onChange"
            @clear="onClean"
            ref="siteAutoComplete"
            placeholder="请输入站点名称/ID"
    >
        <el-option
            v-if="dataType==1"
            label="全部"
            value="0"
        >
        </el-option>
        <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="item.id">
        </el-option>
        
    </el-select>
  </el-tooltip>
</template>
<script>
    import { getSitesAutoComplete } from '@/service/site'
    // 目前不支持多选
    export default{
        props: {
            dataType:[Number, String],
            value: [Number, String],
            factorId: [Number, String],
            agentStatus: [Number],
            keyType:{
                type: Number,
                default: 0
            },
            owned: {
                type: Boolean,
                default: false
            },
            initChooseFirst: {
                type: Boolean,
                default: false
            },
            clueId:[Number, String]
        },
        data() {
            return {
                data: null,
                loading: false,
                options: [],
                searchTimeOutHandle: null
            }
        },
        created() {
            if(this.clueId==1){
                this.search(this.value, true)
            }else{
                this.search()
            }
            
            
        },
        watch: {
            value(val) {
                if (val !== this.data && val !== 0) {
                    this.search(val)
                }
            },
            factorId() {
                this.onClean()
                this.search('')
            },
            agentStatus() {
                this.onClean()
                this.search('')
            }
        },
        methods: {
            search(query, isInit = false) {
                this.loading = true
                clearTimeout(this.searchTimeOutHandle)
                let conditions = {}
                if (!!query) {
                    conditions.keyword = query
                }
                if (!!this.factorId) {
                    conditions.factor_id = this.factorId
                }
                if (!!this.agentStatus) {
                    conditions.agent_status = this.agentStatus
                }
                if (!!this.owned) {
                    conditions.owned = this.owned ? 1 : 0
                }
                let that = this
                let timeout = isInit ? 0 : 300
                this.searchTimeOutHandle = setTimeout(() => {
                    getSitesAutoComplete(conditions).then(async (response) => {
                        that.loading = false
                        that.options = response
                        that.data = null
                        if (response.length > 0) {
                            if (!!that.value) {
                                that.options.forEach(item => {
                                    if (item.id === that.value) {
                                        that.data = that.value
                                    }
                                })
                            } else if (that.initChooseFirst) {
                                await new Promise(resolve => {
                                    that.$nextTick(() => {
                                        if(this.keyType == 1){
                                            that.data = response[0].name
                                        }else{
                                            that.data = response[0].id
                                        }
                                        resolve()
                                    })
                                })
                            }
                        }
                        that.onChange()
                        if (isInit) {
                            that.$emit('created', that.data)
                        }
                    }).catch(err => {
                        console.log(err)
                        that.loading = false
                    })
                }, timeout)
            },
            onChange(item) {
                this.$emit('input', this.data)
                this.$emit('change', this.data)
            },
            onClean() {
                // this.options = []
                this.data = null
                this.$emit('input', '')
            },
            reset () {
                this.search(this.value, true)
            }
        },
    }
</script>
